module.exports = __webpack_public_path__ + "img/BannerImage.51c9e9d4.png";